import React, { useState, useEffect } from "react";
import { LinkContainer } from "react-router-bootstrap";
import { useAppContext} from "../libs/contextLib";
import { useHistory } from "react-router-dom";
import { s3Get, s3PublicUpload, s3PublicDelete } from "../libs/awsLib";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ImageSocial from "../components/ImageSocial";
import Modal from "react-bootstrap/Modal";
import InfoIcon from '../components/InfoIcon';
import LoaderButton from "../components/LoaderButton";
import { onError } from "../libs/errorLib";
import { saveBusiness } from "../services/Business";
import { useLoader } from '../context/LoaderContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./SocialContent.css";

export default function SocialContent() {
    const { isAuthenticated, business, setBusiness, stampsImageList } = useAppContext();
    const [isLoading, setIsLoading] = useState(true);
    const [isProcessing, setIsProcessing] = useState(false);
    const [initialCoverPhoto, setInitialCoverPhoto] = useState(null);
    const history = useHistory();
    const [,setLoading] = useLoader();
    const [facebookCoverImage, setFacebookCoverImage] = useState("");
    const [googleCoverImage, setGoogleCoverImage] = useState(null);
    const [yelpCoverImage, setYelpCoverImage] = useState(null);
    const [instagramCoverImage, setInstagramCoverImage] = useState(null);
    const [hasSocialImages, setHasSocialImages] = useState(false);
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [downloadPlatformType, setDownloadPlatformType] = useState(false);

    useEffect(()=> {
    //ensures window scrolls to top when loading this page
        //window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        console.log("*****calling useEffect")

        async function onLoad() {
            if (!isAuthenticated || !business) {
                return;
            }

            //load social images that the user has uploaded
            var hasImagePersisted = false;
            if (business && business.facebookCoverImage) {
                setFacebookCoverImage(business.facebookCoverImage);
                hasImagePersisted = true;
            }
            if (business && business.googleCoverImage) {
                setGoogleCoverImage(business.googleCoverImage);
                hasImagePersisted = true;
            }
            if (business && business.yelpCoverImage) {
                setYelpCoverImage(business.yelpCoverImage);
                hasImagePersisted = true;
            }
            if (business && business.instagramCoverImage) {
                setInstagramCoverImage(business.instagramCoverImage);
                hasImagePersisted = true;
            }
            if (hasImagePersisted) {
                setHasSocialImages(true);
            }
            setIsLoading(false);
        }
  
        onLoad();
    }, []);

    useEffect(() => {
        setLoading(isLoading);
    }, [isLoading, setLoading]);

    async function handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        setIsLoading(true);
        try {
            const params = {};
            //check if business has gone through onboarding before
            //if not, update the date at this step since onboarding is completed
            if (!business.onboardingCompletionDate) {
                var now = new Date().toISOString();
                params["onboardingCompletionDate"] = now;
                await saveBusiness(business.businessId, params);
                business.onboardingCompletionDate = now;
                setBusiness(business);
            }
            setIsLoading(false);
            history.push("/thankyou");
        } catch (e) {
            onError(e);
            setIsLoading(false);
        }
    }

    const updateSocialImage = async (fileName, platformType) => {
        //console.log("*******in updateSocialImage: fileName: " + fileName + ", platformType: " + platformType);

        let hasChanges = false;
        const params = {};
        if (platformType === 'facebook' && fileName !== business.facebookCoverImage) {
            params["facebookCoverImage"] = fileName;
            hasChanges = true;
        }
        if (platformType === 'google' && fileName !== business.googleCoverImage) {
            params["googleCoverImage"] = fileName;
            hasChanges = true;
        }
        if (platformType === 'yelp' && fileName !== business.yelpCoverImage) {
            params["yelpCoverImage"] = fileName;
            hasChanges = true;
        }
        if (platformType === 'instagram' && fileName !== business.instagramCoverImage) {
            params["instagramCoverImage"] = fileName;
            hasChanges = true;
        }

        if (hasChanges) {
            //console.log("*********Params: " + JSON.stringify(params));
            await saveBusiness(business.businessId, params);

            //update business info
            if (platformType === 'facebook') {
                setFacebookCoverImage(fileName);
            }
            if (platformType === 'google') {
                setGoogleCoverImage(fileName);
            }
            if (platformType === 'yelp') {
                setYelpCoverImage(fileName);
            }
            if (platformType === 'instagram') {
                setInstagramCoverImage(fileName);
            }
        }
    };

    const removeSocialImage= async (fileName, platformType) => {
        //console.log("*******in removeSocialImage: fileName: " + fileName + ", platformType: " + platformType);

        //Remove from S3
        try {
            await s3PublicDelete(fileName);

            //Remove from DB
            let hasChanges = false;
            const params = {};
            if (platformType === 'facebook') {
                params["facebookCoverImage"] = '';
                hasChanges = true;
            }
            if (platformType === 'google') {
                params["googleCoverImage"] = '';
                hasChanges = true;
            }
            if (platformType === 'yelp') {
                params["yelpCoverImage"] = '';
                hasChanges = true;
            }
            if (platformType === 'instagram') {
                params["instagramCoverImage"] = '';
                hasChanges = true;
            }

            if (hasChanges) {
                console.log("*********Params: " + JSON.stringify(params));
                await saveBusiness(business.businessId, params);

                //update business info
                if (platformType === 'facebook') {
                    setFacebookCoverImage('');
                }
                if (platformType === 'google') {
                    setGoogleCoverImage('');
                }
                if (platformType === 'yelp') {
                    setYelpCoverImage('');
                }
                if (platformType === 'instagram') {
                    setInstagramCoverImage('');
                }
            }
        } catch (e) {

        }
    };

    /**
     * For initial onboarding (i.e. no social images were uploaded at all), provide a single upload that will populate all 4 social panels for edit
     * @param {*} event 
     */
    const addInitialCoverPhoto = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        setIsProcessing(true);
        setLoading(true);
        try {
            var file = event.target.files[0];
            const s3FileName = file ? await s3PublicUpload(file) : null;
            setInitialCoverPhoto(s3FileName);
            setHasSocialImages(true); //display the social image panels
        } catch (e) {
            onError(e);
        }
        setIsProcessing(false);
        setLoading(false);
    }

    /**
     * Download file content and go to social platform
     * @param {*} filename 
     * @param {*} platformType 
     */
    const downloadImage = async (filename, platformType) => {

        try {
            //Download image blob using s3 link
            const s3FileName = await s3Get(filename);
            let blob = await fetch(s3FileName).then(r => r.blob());
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
            setDownloadPlatformType(platformType);
            setShowDownloadModal(true);
        } catch (e) {
            //TODO: show error modal
            console.log("*****image not found: ");
        }
    }

    const clickClose = (event, downloadPlatformType) => {
        //console.log("****clickClose: " + downloadPlatformType)
        
        //Open new window tab for platform type user
        let socialWebsiteUrl = getSocialWebsiteUrl(downloadPlatformType);
        if (socialWebsiteUrl && socialWebsiteUrl !== null) {
            window.open(socialWebsiteUrl, "_blank", "noopener,noreferrer");
        }
        setShowDownloadModal(false);
        setDownloadPlatformType(null);
    }

    /**
     * Helper function to get the social website's URL
     * @param {string} platformType 
     */
    const getSocialWebsiteUrl = (platformType) => {
        if (platformType === 'facebook') {
            return "https://www.facebook.com";
        } else if (platformType === 'google') {
            return "https://business.google.com/";
        } else if (platformType === 'yelp') {
            return "https://biz.yelp.com";
        } else if (platformType === 'instagram') {
            return "https://www.instagram.com";
        } else {
            return null;
        }
    }

    return (
        <div className="socialContent">
            {isAuthenticated && !isLoading && (
                <div className="content">
                    <div className="contentHeader">
                        <h2>3. Customize Your Images</h2>
                        <h4>Using our preset photo formats, apply Sertify Stamps to your digital accounts.</h4>
                    </div>
                    <Form onSubmit={handleSubmit}>
                        <div className="contentBody">
                            { 
                            //If no social images persisted yet, offer a convenient single upload to all social cover photos
                            !hasSocialImages && (
                                <>
                                <div className="contentBody">
                                    <ul>
                                        <li>Google Photo Gallery</li>
                                        <li>Yelp Photo Gallery</li>
                                        <li>Facebook Cover Photo</li>
                                        <li>Instagram Post</li>
                                    </ul>
                                </div>
                                <div className="row-bottom-20">
                                    3a. Upload or take a cover photo for your digital channels
                                </div>
                                <div className="FileUpload row-bottom-20 center-text">
                                    <div className="uploadImageContainer">
                                        <input
                                            type="file"
                                            id="imgupload" 
                                            onClick={(event) => {
                                                //reset the value so that onChange will fire again if user uploads the same file
                                                event.target.value = '';
                                            }}
                                            onChange={e => addInitialCoverPhoto(e)}
                                            style={{display:"none"}}
                                            />
                                        <label htmlFor="imgupload">
                                            <FontAwesomeIcon icon={['fas', 'cloud-upload-alt']} size="4x"></FontAwesomeIcon><br/>
                                            <span>&nbsp;Add Photo</span>
                                        </label>
                                       
                                    </div>
                                </div>
                                </>
                            )}
                            { hasSocialImages && ( 
                                <div>
                                    <div className="row-bottom-20 left-text">
                                        <p>3b. For each platform, add a stamp to your photo.
                                            <InfoIcon 
                                                keyName={"socialMedia"}
                                                message={"If you'd like different photos for each platform, you can click the top left X to replace the photo."}
                                            />
                                        </p>
                                        <p>3c. Download your photo and upload to your digital channels.</p>
                                    </div>
                                    <div className="socialMediaContainer row-bottom-20">
                                        <div className="item">
                                            <div className="container">
                                                <div className="container-logo">
                                                    <FontAwesomeIcon icon={['fab', 'facebook']} size="2x"></FontAwesomeIcon>
                                                </div>
                                                <div className="container-text">
                                                    <span>Facebook</span>
                                                </div>
                                            </div>
                                            <ImageSocial 
                                                platformType={"facebook"}
                                                setImageObject={updateSocialImage}
                                                removeImageObject={removeSocialImage}
                                                loadSrc={facebookCoverImage ? facebookCoverImage : initialCoverPhoto}
                                                stickers={stampsImageList}
                                                outputWidth={851}
                                                outputHeight={315}
                                            />
                                            {   //only offer download button if image is a persisted image 
                                                facebookCoverImage && (
                                                    <div className="linkBtn"> 
                                                        <Button onClick={() => downloadImage(facebookCoverImage, "facebook")}>
                                                            <FontAwesomeIcon icon={['fas', 'cloud-download-alt']}></FontAwesomeIcon>
                                                        </Button>
                                                        <div className="linkBtn-link" onClick={() => downloadImage(facebookCoverImage, "facebook")}>Download</div>
                                                    </div>
                                                
                                            )}
                                        </div>
                                        
                                        <div className="item">
                                            <div className="container">
                                                <div className="container-logo">
                                                    <FontAwesomeIcon icon={['fab', 'google']} size="2x"></FontAwesomeIcon>
                                                </div>
                                                <div className="container-text">
                                                    <span>Google</span>
                                                </div>
                                            </div>
                                            <ImageSocial 
                                                platformType={"google"}
                                                setImageObject={updateSocialImage}
                                                removeImageObject={removeSocialImage}
                                                loadSrc={googleCoverImage ? googleCoverImage : initialCoverPhoto}
                                                stickers={stampsImageList}
                                                outputWidth={1080}
                                                outputHeight={1080}
                                            />
                                            {   // only offer download button if image is a persisted image 
                                                googleCoverImage && (
                                                    <div className="linkBtn"> 
                                                        <Button onClick={() => downloadImage(googleCoverImage, "google")}>
                                                            <FontAwesomeIcon icon={['fas', 'cloud-download-alt']}></FontAwesomeIcon>
                                                        </Button>
                                                        <div className="linkBtn-link" onClick={() => downloadImage(googleCoverImage, "google")}>Download</div>
                                                    </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="socialMediaContainer">
                                        <div className="item">
                                            <div className="container">
                                                <div className="container-logo">
                                                    <FontAwesomeIcon icon={['fab', 'yelp']} size="2x"></FontAwesomeIcon>
                                                </div>
                                                <div className="container-text">
                                                    <span>Yelp</span>
                                                </div>
                                            </div>
                                            <ImageSocial 
                                                platformType={"yelp"}
                                                setImageObject={updateSocialImage}
                                                removeImageObject={removeSocialImage}
                                                loadSrc={yelpCoverImage ? yelpCoverImage : initialCoverPhoto}
                                                stickers={stampsImageList}
                                                outputWidth={1080}
                                                outputHeight={1080}
                                            />
                                            {   // only offer download button if image is a persisted image 
                                                yelpCoverImage && (
                                                    <div className="linkBtn"> 
                                                        <Button onClick={() => downloadImage(yelpCoverImage, "yelp")}>
                                                            <FontAwesomeIcon icon={['fas', 'cloud-download-alt']}></FontAwesomeIcon>
                                                        </Button>
                                                        <div className="linkBtn-link" onClick={() => downloadImage(yelpCoverImage, "yelp")}>Download</div>
                                                    </div>
                                            )}
                                        </div>
                                        <div className="item">
                                            <div className="container">
                                                <div className="container-logo">
                                                    <FontAwesomeIcon icon={['fab', 'instagram']} size="2x"></FontAwesomeIcon>
                                                </div>
                                                <div className="container-text">
                                                    <span>Instagram</span>
                                                </div>
                                            </div>
                                            <ImageSocial 
                                                platformType={"instagram"}
                                                setImageObject={updateSocialImage}
                                                removeImageObject={removeSocialImage}
                                                loadSrc={instagramCoverImage ? instagramCoverImage : initialCoverPhoto}
                                                stickers={stampsImageList}
                                                outputWidth={1080}
                                                outputHeight={1080}
                                            />
                                            {   // only offer download button if image is a persisted image 
                                                instagramCoverImage && (
                                                    <div className="linkBtn"> 
                                                        <Button onClick={() => downloadImage(instagramCoverImage, "instagram")}>
                                                            <FontAwesomeIcon icon={['fas', 'cloud-download-alt']}></FontAwesomeIcon>
                                                        </Button>
                                                        <div className="linkBtn-link" onClick={() => downloadImage(instagramCoverImage, "instagram")}>Download</div>
                                                    </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        {   //Modal that shows up after user clicks on Download button for one of the social images
                            <Modal show={showDownloadModal} onHide={e => clickClose(e, downloadPlatformType)} backdrop="static" className="App">
                                <Modal.Header closeButton>
                                    <Modal.Title>Download complete</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div>To make it easy, we're opening <span className="capitalize">{downloadPlatformType}</span> so you can upload your image.</div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <div className="modalButtons">
                                        <Button variant="primary" onClick={e => clickClose(e, downloadPlatformType)}>
                                            OK
                                        </Button>
                                    </div>
                                </Modal.Footer>
                            </Modal>
                        }
                        {   //show Back/Next buttons if user is going through onboarding for first time
                            hasSocialImages && !business.onboardingCompletionDate && (
                            <div className="pageButtons-multiple">
                                <LinkContainer key="backStamps" to="/stamps">
                                    <Button variant="secondary">BACK</Button>
                                </LinkContainer>
                                <LoaderButton
                                        key="nextThankYou"
                                        type="submit"
                                        variant="primary"
                                        value='next'
                                        isLoading={isLoading}       
                                    >NEXT
                                </LoaderButton>
                            </div>
                        )}
                        { /* User has completed onboarding.  Show "DONE" button instead of "Next" */
                            hasSocialImages && business.onboardingCompletionDate && (
                            <div className="pageButtons-single row-top-10">
                                <Button variant="primary" onClick={event => handleSubmit(event, 'home')}>DONE</Button>
                            </div>
                        )}
                    </Form>
                </div>
            )}
        </div>
    );
}
